//
// DataType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var DataType = {
    NUMBER:0,
    STRING:1,
    UNDEFINED:2
};
export default DataType;
